<template>
  <div class="comp-tool">
    <div class="tool__container u-page-container">
      <h1 class="tool__title">Hello!</h1>
      <p class="tool__desc">請選擇教具</p>
      <div class="tool__entry" :class="{ 'too_entry--padding': roleType === 'assistant' }">
        <div
          class="tool__entry-block"
          data-tool="presentation">
          <a
            href="#"
            class="tool__entry-link u-flex-center-center"
            @click.prevent="goTo('presentation')">
            <div class="tool__entry-bg u-flex-center-center">
              <h3 class="tool__entry-title">線上簡報</h3>
              <p class="tool__entry-desc">作業繳交平台</p>
            </div>
          </a>
        </div>
        <div
          class="tool__entry-block"
          data-tool="puzzle">
          <a
            href="#"
            class="tool__entry-link u-flex-center-center"
            @click.prevent="goTo('puzzle')">
            <div class="tool__entry-bg u-flex-center-center">
              <h3 class="tool__entry-title">拼圖遊戲</h3>
              <p class="tool__entry-desc">訓練溝通、表達力</p>
            </div>
          </a>
        </div>
        <div
          v-if="roleType === 'student'"
          class="tool__entry-block"
          data-tool="eyes-contact">
          <a
            href="#"
            class="tool__entry-link u-flex-center-center"
            @click.prevent="goTo('eyes-contact')">
            <div class="tool__entry-bg u-flex-center-center">
              <h3 class="tool__entry-title">打地鼠</h3>
              <p class="tool__entry-desc">訓練穩定度、觀察力</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { navigateTool } from '@/utils/sharefunc'
import { mapGetters } from 'vuex'

export default {
  name: 'Tool',
  computed: {
    ...mapGetters(['roleType'])
  },
  methods: {
    goTo (tool) {
      navigateTool(tool)
    }
  }
}
</script>
